// extracted by mini-css-extract-plugin
module.exports = {"btn":"HPa1","active":"HPs3"};